import { render, staticRenderFns } from "./PayQrcode.vue?vue&type=template&id=4faaedaa&scoped=true"
import script from "./PayQrcode.vue?vue&type=script&lang=js"
export * from "./PayQrcode.vue?vue&type=script&lang=js"
import style0 from "./PayQrcode.vue?vue&type=style&index=0&id=4faaedaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faaedaa",
  null
  
)

export default component.exports